// extracted by mini-css-extract-plugin
export default {"wrap":"aI-z","fullWidth":"bI-z","hideOnDesktop":"cI-z","content":"dI-z","hasOpenedNav":"eI-z","crumbsList":"fI-z","dropdownsWrap":"gI-z"};